import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { DeviceStatus } from '../../enums/deviceStatus';
import { Device } from '../../interfaces';
import { baseColors } from '../../theme';
import { Dot } from './dot';

interface Props {
  device: Device;
}

export function ProvisioningStatus(props: Props) {
  let color = 'gray';
  const { status } = props.device;

  switch (status) {
    case DeviceStatus.provisionedStr:
      color = baseColors.green;
      break;
    case DeviceStatus.provisioningErrorStr:
      color = baseColors.red;
      break;

    case DeviceStatus.provisioningInitiatedStr:
      color = baseColors.orange;
      break;

    case DeviceStatus.registeredStr:
      color = baseColors.lightGreen;
  }

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{status}</Tooltip>}>
      <Dot color={color} data-provisioning-status={status} />
    </OverlayTrigger>
  );
}
